import React from 'react';
import { Tag as BPTag, TagProps as ITagProps } from '@blueprintjs/core';
import cc from 'classcat';

/**
 * Extends Blueprint <Tag />
 * https://blueprintjs.com/docs/#core/components/tag
 */

interface TagProps extends ITagProps {
  text: string;
}

const Tag: React.FC<TagProps> = ({ text, className, ...props }) => {
  const classes = cc([className, 'px-2', 'ma-1', 'lh-1']);
  return (
    <BPTag className={classes} {...props}>
      {text}
    </BPTag>
  );
};

export default Tag;
